<script>
    import { fade } from 'svelte/transition';

    let { open = $bindable(false), class: className = '', close, children } = $props();

    function handleBackdropClick() {
        if (close) {
            close();
        }
        open = false;
    }

    // Flag the body while any modal is open so the floating notification bell hides.
    $effect(() => {
        if (!open) return;
        document.body.classList.add('overlay-open');
        return () => document.body.classList.remove('overlay-open');
    });
</script>

{#if open}
    <div class="modal-overlay" transition:fade={{ duration: 200 }}>
        <!-- svelte-ignore a11y_no_static_element_interactions -->
        <!-- svelte-ignore a11y_click_events_have_key_events -->
        <div class="modal-backdrop" onclick={handleBackdropClick}></div>
        <div class="modal-content modal {className}">
            {@render children?.()}
        </div>
    </div>
{/if}

<style>
    :global(.modal-overlay) {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1000;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    :global(.modal-backdrop) {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.6);
    }
    :global(.modal-content) {
        position: relative;
        z-index: 1;
        max-width: 90vw;
        max-height: 90vh;
        overflow: auto;
    }
</style>
